import createConverter from './lib/create_converter';
import CustomerAssignee from 'models/customer_assignee';

export default createConverter(CustomerAssignee);
